import * as React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import HashLink from '../Common/HashLink';

const jss = (theme: Theme) => createStyles({
    listItem: {
        borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
        borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    },
    delete: {
        color: theme.palette.error.main,
    },
});

interface Props {
    quiz: Bee.Quiz;
    link: string;
    publish: (id: string) => void;
    unpublish: (id: string) => void;
    delete: (id: string) => void;
    edit: (quiz: Bee.Quiz) => void;
    classes: {
        listItem: string;
        delete: string;
    }
}

interface State {
    anchorEl: any;
}

class QuizRow extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            anchorEl: null,
        }
    }

    handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        this.setState({ anchorEl: event.currentTarget });
    };
    
    handleClose = () => {
        this.setState({ anchorEl: null });
    };

    private onPublish = () => {
        this.setState({ anchorEl: null });
        this.props.publish(this.props.quiz.id);
    }

    private onUnpublish = () => {
        this.setState({ anchorEl: null });
        this.props.unpublish(this.props.quiz.id);
    }

    private onDelete = () => {
        this.setState({ anchorEl: null });
        this.props.delete(this.props.quiz.id);
    }

    private onEdit = () => {
        this.setState({ anchorEl: null });
        this.props.edit(this.props.quiz);
    }

  	render() {
        const { classes, quiz } = this.props;
        
        return (
            <ListItem
                key={quiz.id}
                button
                divider
                component={HashLink}
                className={classes.listItem}
                // @ts-ignore
                to={this.props.link}
            >   
                <ListItemText
                    primary={quiz.title}
                    secondary={quiz.state}
                    primaryTypographyProps={{
                        variant: 'h6',
                    }}
                />
                <ListItemSecondaryAction>
                    <IconButton
                        onClick={this.handleClick}
                        disabled={(quiz.state !== 'pending' && quiz.state !== 'created')}
                    >
                        <MoreVertIcon />
                    </IconButton>
                    <Menu
                        anchorEl={this.state.anchorEl}
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.handleClose}
                        PaperProps={{
                            style: {
                            maxHeight: 48 * 4.5,
                            width: 200,
                            },
                        }}
                    >
                        {quiz.state === 'created' && <MenuItem key="publish" onClick={this.onPublish}>
                            Publish
                        </MenuItem>}
                        {quiz.state === 'created' && <MenuItem key="Edit" onClick={this.onEdit}>
                            Edit
                        </MenuItem>}
                        {quiz.state === 'pending' && <MenuItem key="unpublish" onClick={this.onUnpublish}>
                            Unpublish
                        </MenuItem>}
                        <MenuItem key="delete" className={classes.delete} onClick={this.onDelete}>
                            Delete
                        </MenuItem>
                    ))}
                    </Menu>
                </ListItemSecondaryAction>
            </ListItem>
        )
	}
}

export default withStyles(jss)(QuizRow);



// WEBPACK FOOTER //
// ./src/components/Admin/QuizRow.tsx